import { useRouteMatch } from 'react-router-dom'

import {
  GetFrameAnnotationInfoDocument,
  GetFrameAnnotationInfoQuery,
  GetFrameAnnotationInfoQueryVariables,
  useApolloClient,
  useDeleteAnnotationMutation,
} from '@sketch/gql-types'
import { removeFromPaginated } from '../../utils/apolloCache'
import { routes, usePreviewPwd } from '../../routes'

interface useDeleteAnnotationCommentProps {
  identifier: string
  onCompleted?: () => void
}

const useDeleteAnnotation = ({
  identifier,
  onCompleted,
}: useDeleteAnnotationCommentProps) => {
  const apollo = useApolloClient()

  const previewRouteMatch = useRouteMatch<{ previewID?: string }>(
    routes.PREVIEW_VIEW.template()
  )
  const previewIdentifier = previewRouteMatch?.params.previewID
  const previewPassword = usePreviewPwd(previewIdentifier || '')

  const [mutate, { loading }] = useDeleteAnnotationMutation({
    variables: { identifier, previewIdentifier, previewPassword },
    onError: 'show-toast',
    onCompleted: data => {
      const frameUUID = data?.deleteAnnotation.annotation.frameUuid
      const shareIdentifier = data?.deleteAnnotation.annotation.share.identifier
      if (frameUUID && shareIdentifier) {
        apollo.query<
          GetFrameAnnotationInfoQuery,
          GetFrameAnnotationInfoQueryVariables
        >({
          query: GetFrameAnnotationInfoDocument,
          variables: {
            frameUUID,
            shareIdentifier,
          },
        })
      }
      onCompleted && onCompleted()
    },
    update: (cache, { data }) => {
      if (data?.deleteAnnotation) {
        removeFromPaginated(
          cache,
          { __typename: 'Annotation', identifier },
          () => true
        )
      }
    },
  })
  return [mutate, { loading }] as const
}

export default useDeleteAnnotation
